import { useMemo } from 'react';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../translations';
import { VisitSettlementFormController } from '../VisitSettlementForm';

import { PAYMENT_METHODS, PaymentMethod } from './payment.types';

const t = visitSettlementTranslationKeys.shared.form.payment.methodRadioGroup;

const radioGroupItems: RadioGroupItem<PaymentMethod>[] = PAYMENT_METHODS.map((method) => ({
   id: method,
   label: t.map[method],
}));

type PaymentMethodRadioGroupProps = Pick<VisitSettlementFormController, 'register'>;

export const PaymentMethodRadioGroup = (props: PaymentMethodRadioGroupProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: true,
      };
   }, []);

   return (
      <RadioGroup
         testId={'paymentMethod'}
         label={t.label}
         controller={props.register('payment.method', validationRules)}
         items={radioGroupItems}
         horizontal
      />
   );
};
